import React, { useEffect } from "react";
import { MapContainer, TileLayer, CircleMarker, Circle, Polyline, Tooltip, useMap } from "react-leaflet";

function Fly({ target, zoom }) {
  const map = useMap();
  useEffect(() => { if (target) map.flyTo(target, zoom || map.getZoom(), { duration: 0.8 }); }, [target, zoom, map]);
  return null;
}

export default function MapCanvas({ points = [], selectedId, onSelect, circles = [], lines = [], center = [-25.5, 27.5], zoom = 6, height = 520, children, flyTo, testid = "map-canvas" }) {
  return (
    <div className="relative rounded-[18px] overflow-hidden border border-[#2a2f36] shadow-xl sat" style={{ height }} data-testid={testid}>
      <MapContainer center={center} zoom={zoom} scrollWheelZoom style={{ height: "100%", width: "100%" }} zoomControl={false} attributionControl={true}>
        <TileLayer url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}" attribution="Esri World Imagery" />
        <TileLayer url="https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}" attribution="Esri Reference" />
        {circles.map((c, i) => <Circle key={i} center={[c.lat, c.lng]} radius={c.radiusKm * 1000} pathOptions={{ color: c.color || "#C5A059", weight: 1.5, fillOpacity: 0.08, dashArray: "6 6" }} />)}
        {lines.map((l, i) => <Polyline key={i} positions={l.path} pathOptions={{ color: l.color || "#E9C46A", weight: l.weight || 1.4, opacity: l.opacity || 0.75, dashArray: l.dash }} />)}
        {points.map((p) => {
          const sel = p.id === selectedId;
          return (
            <CircleMarker key={p.id} center={[p.lat, p.lng]} radius={sel ? (p.r || 7) + 5 : p.r || 7} eventHandlers={{ click: () => onSelect?.(p) }}
              pathOptions={{ color: sel ? "#FFF7E0" : "#ffffff", weight: sel ? 3 : 1.5, fillColor: p.color, fillOpacity: p.dim ? 0.3 : 0.95 }}>
              <Tooltip direction="top" offset={[0, -6]}>{p.label}</Tooltip>
            </CircleMarker>
          );
        })}
        {flyTo && <Fly target={flyTo} zoom={flyTo.zoom} />}
      </MapContainer>
      {children}
    </div>
  );
}

export const Legend = ({ items }) => (
  <div className="absolute bottom-3 left-3 z-[500] flex flex-wrap gap-1.5">
    {items.map((i) => <span key={i.label} className="pill bg-white/95 border-white text-[#1C1917]"><span className="w-2 h-2 rounded-full" style={{ background: i.color }} />{i.label}</span>)}
  </div>
);
